import { render, staticRenderFns } from "./verifyTenant.vue?vue&type=template&id=9cabe238&scoped=true"
import script from "./verifyTenant.vue?vue&type=script&lang=js"
export * from "./verifyTenant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cabe238",
  null
  
)

export default component.exports